import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

const SectionHeading = ({ title, icon }) => {
  return (
    <h1 style={{ color: "var(--secondary-color)" }}>
      <Icon type={icon} /> {title}
    </h1>
  );
};

SectionHeading.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired
};

export default SectionHeading;



// WEBPACK FOOTER //
// ./src/components/section_heading/SectionHeading.jsx